import { render, staticRenderFns } from "./ParPriceList.vue?vue&type=template&id=45b5fb5f"
import script from "./ParPriceList.vue?vue&type=script&lang=js"
export * from "./ParPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports